module.exports = __webpack_public_path__ + "4693e3eebefafa6c132dc4d9e492b890.svg";